export default __webpack_public_path__ + "media/images/new_year/mosaic_1920x1080-0a05866dd4fc99fe6a9cab5326607f8d.webp";